export default __webpack_public_path__ + "static/media/Splash.f119aea9.png";